import { render, staticRenderFns } from "./ElBillingTerms.vue?vue&type=template&id=52661734"
import script from "./ElBillingTerms.vue?vue&type=script&lang=js"
export * from "./ElBillingTerms.vue?vue&type=script&lang=js"
import style0 from "./ElBillingTerms.vue?vue&type=style&index=0&id=52661734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports